// Navbar.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';
import LanguageToggle from './LanguageToggle';
import salientLogo from '../../assets/images/logos/salient_logo.png';
import { useLanguage } from '../../i18n/LanguageContext';

const Navbar = () => {
  const { t } = useLanguage();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  
  // Toggle menu function
  const toggleMenu = () => setMenuOpen(!isMenuOpen);
  
  // Handle scroll event for navbar appearance
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Define menu items with their submenus (etiquetas traducidas)
  const menuItems = [
    {
      label: t('nav.inicio'),
      path: '/'
    },
    {
      label: t('nav.tecnologia'),
      path: '/tecnologia/redes',
      submenu: [
        {
          label: t('nav.redes'),
          path: '/tecnologia/redes'
        },
        {
          label: t('nav.cctv'),
          path: '/tecnologia/cctv'
        },
        {
          label: t('nav.software'),
          path: '/tecnologia/software'
        },
      ]
    },
    {
      label: t('nav.otrosServicios'),
      path: '/otros-servicios',
      submenu: [
        {
          label: t('nav.marketing'),
          path: '/marketing'
        },
        {
          label: t('nav.energias'),
          path: '/otros-servicios'
        },
        {
          label: t('nav.equipos'),
          path: '/equipos'
        },
        // {
        //   label: 'Proyectos de Alta Tensión',  // TODO: reactivar cuando haya contenido
        //   path: '/otros-servicios#alta-tension'
        // },
      ]
    },
    {
      label: t('nav.quienesSomos'),
      path: '/about-us',
    },
    {
      label: t('nav.contactanos'),
      path: '/contact'
    },
  ];

  return (
    <nav 
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 bg-salient-navy border-b border-white/5 ${
        isScrolled
          ? 'backdrop-blur-sm shadow-lg py-4'
          : 'py-6'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center" 
            aria-label="Salient Homepage"
          >
            <div className="text-2xl font-bold relative">
              {/* <span className="relative z-10 transition-all duration-300 bg-clip-text text-white hover:to-blue-500">
                SALIENT
              </span> 
              <span className="absolute -bottom-1 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-green-400 opacity-70 rounded-full"></span>
              */}
              <img src={salientLogo} alt="Salient Logo" className={`h-auto transition-all duration-300 ${isScrolled ? 'w-32' : 'w-48'}`}/>              
            </div>
          </Link>

          {/* Toggle de idioma + Menu Burger (móvil) */}
          <div className="lg:hidden flex items-center gap-3">
            <LanguageToggle />
            <button
              onClick={toggleMenu}
              className="flex items-center p-2 rounded-md hover:bg-gray-100 transition-colors duration-300"
              aria-expanded={isMenuOpen}
              aria-label="Toggle navigation menu"
            >
              <div className="relative w-6 h-5">
                <span 
                  className={`absolute h-0.5 w-6 bg-gray-800 transform transition-all duration-300 rounded-full ${
                    isMenuOpen ? 'rotate-45 top-2' : 'top-0'
                  }`}
                ></span>
                <span 
                  className={`absolute h-0.5 w-6 bg-gray-800 top-2 transition-all duration-300 rounded-full ${
                    isMenuOpen ? 'opacity-0' : 'opacity-100'
                  }`}
                ></span>
                <span 
                  className={`absolute h-0.5 w-6 bg-gray-800 transform transition-all duration-300 rounded-full ${
                    isMenuOpen ? '-rotate-45 top-2' : 'top-4'
                  }`}
                ></span>
              </div>
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-4">
            <DesktopMenu menuItems={menuItems} isScrolled={isScrolled} />
            <LanguageToggle />
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <MobileMenu 
        isOpen={isMenuOpen} 
        menuItems={menuItems} 
        toggleMenu={toggleMenu}
      />
    </nav>
  );
};

export default Navbar;